export const LoadingIcon = () => (
  <svg className="loading-spinner" width="48" height="48" viewBox="0 0 50 50">
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke="#0d6efd"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="90 150"
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg width="56" height="56" viewBox="0 0 52 52">
    <circle cx="26" cy="26" r="25" fill="#e6f4ea" />
    <path
      fill="none"
      stroke="#198754"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 27 l7 7 l17 -17"
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg width="56" height="56" viewBox="0 0 52 52">
    <circle cx="26" cy="26" r="25" fill="#fdecea" />
    <path
      stroke="#dc3545"
      strokeWidth="4"
      strokeLinecap="round"
      d="M16 16 L36 36 M36 16 L16 36"
    />
  </svg>
);

export const TimeoutIcon = () => (
  <svg width="56" height="56" viewBox="0 0 52 52">
    <circle cx="26" cy="26" r="25" fill="#fff4e5" />
    <path
      d="M26 14 v14 l8 4"
      fill="none"
      stroke="#fd7e14"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);
